import { createContext, useContext } from 'react'

export type OpenModalFn = (direction?: Seat.TripDirection, segment?: Segment) => void
export type SetSeatsFn = (
  seats: (Seat.ByTripDirection | null) | ((prev: Seat.ByTripDirection | null) => Seat.ByTripDirection | null),
) => void

export const SeatSelectionContext = createContext<{
  openModal: OpenModalFn
  setSeats: SetSeatsFn
  seats: Seat.ByTripDirection | null
  preselectedSeats?: Seat.ByTripDirection
  scheme: Seat.ByTripDirection<Seat.Train.Segment[]>
  layoutQuery: Seat.Train.Data['layoutQuery']
}>({
  openModal() {},
  seats: null,
  scheme: { outbound: [], inbound: [] },
  layoutQuery: () => undefined,
  setSeats: () => undefined,
})
export const useSeatSelectionContext = () => useContext(SeatSelectionContext)
